(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-chapter-wrapper-section"] && !Shopify.designMode) return;
  try {
    

function slide_chapter_block() {
  this.classList.toggle('active');
  document.querySelector('.stickeySidebar_inner_mobile_chapter_dots_list').classList.toggle('active');
}
document.querySelector('.mob_short_chapter_btn').addEventListener('click', slide_chapter_block);  
  
/* >> Wrap all Chapter Section : Start */  

    var newElem = document.createElement('div')
    newElem.classList.add("page-chapter-wrapper-block-list");
    Array.prototype.forEach.call(document.querySelectorAll('.page-sectionChapter'), function(c){
      newElem.appendChild(c);
    });
    
    var get_chp_wrap = document.querySelector('.page-chapter-wrapper-section').appendChild(newElem)

/* Wrap all Chapter Section : End */  

/* >> Create Chapter Link Side Bar Section : Start */    
  
    document.addEventListener( 'DOMContentLoaded', function () {
        setTimeout(function(){        
            const chapter_elements = document.querySelectorAll('.page-sectionChapter');
            const chapter_list_elements = document.querySelectorAll('.stickeySidebar_inner_chapter_list');
            const chapter_list_mobile_elements = document.querySelectorAll('.stickeySidebar_inner_mobile_chapter_list');
            let total_chapter_count = 0;
              
            chapter_elements.forEach( el => {
              //el.innerHTML = "foo";
              console.log(el);
                total_chapter_count = total_chapter_count + 1;
                var targetDiv_id = el.getElementsByClassName("chapter_section_outer_block")[0].getAttribute('id');
                var targetDiv_chapter_index_title = el.getElementsByClassName("chapter_index_title")[0].textContent;
                var targetDiv_chapter_section_title = el.getElementsByClassName("chapter_block_title")[0].textContent;
                console.log(targetDiv_chapter_index_title+" = "+targetDiv_chapter_section_title);
                var set_chapter_link_item = '<a class="navigation__link active" href="#'+targetDiv_id+'"> <p class="bold chapterHead">'+targetDiv_chapter_index_title+'</p>  <p class="chapterCont">'+targetDiv_chapter_section_title+'</p> </a>';
                console.log(chapter_list_elements);
                console.log(set_chapter_link_item);
              
                var targetDiv_id_hash = '#'+targetDiv_id;
                const chapter_list_item = document.createElement("a");
                chapter_list_item.innerHTML = '<p class="bold chapterHead">'+targetDiv_chapter_index_title+'</p>  <p class="chapterCont">'+targetDiv_chapter_section_title+'</p>';
                chapter_list_item.setAttribute('href',targetDiv_id_hash);
                chapter_list_item.classList.add("navigation__link");                          
                chapter_list_elements[0].appendChild(chapter_list_item);

                const chapter_list_mob_item = document.createElement("a");
                chapter_list_mob_item.innerHTML = '<p class="bold chapterHead">'+targetDiv_chapter_index_title+'<span class="mob_total_chapter"></span></p>  <p class="chapterCont">'+targetDiv_chapter_section_title+'</p>';
                chapter_list_mob_item.setAttribute('href',targetDiv_id_hash);
                chapter_list_mob_item.classList.add("mob_navigation__link");                                        
              
                chapter_list_mobile_elements[0].appendChild(chapter_list_mob_item);
            });   

            const chapter_list_mobile_inner_items = document.querySelectorAll('.mob_navigation__link');
            const chapter_list_mobile_inner_item_dots = document.querySelectorAll('.stickeySidebar_inner_mobile_chapter_dots_list');
            let mob_total_chapter_count = 0;
            chapter_list_mobile_inner_items.forEach( el => {    
                console.log(el);     
                mob_total_chapter_count = mob_total_chapter_count + 1;
                el.getElementsByClassName("mob_total_chapter")[0].textContent += "/"+total_chapter_count;   
                var targetDiv_href_id = el.getAttribute('href');
                const chapter_list_mob_item_dot = document.createElement("a");
                chapter_list_mob_item_dot.innerHTML = '<p class="bold chapterHead">Ch '+mob_total_chapter_count+'</p>';
                chapter_list_mob_item_dot.setAttribute('href',targetDiv_href_id);
                chapter_list_mob_item_dot.classList.add("mob_dot_navigation__link");                                        
              
                chapter_list_mobile_inner_item_dots[0].appendChild(chapter_list_mob_item_dot);                
            });          

          const navLinks = document.querySelectorAll('.navigation.stickeySidebar a');
    
          // Attach click event listeners to each link
          navLinks.forEach(link => {
              link.addEventListener('click', function(e) {
                    //alert("gdf");
                  e.preventDefault();
    
                  // Get the target section's ID from the link's href attribute
                  const targetSectionId = link.getAttribute('href');
    
                  // Use the scrollTo() method to scroll smoothly to the target section
     /*                
                    var scrollDiv = document.querySelector(targetSectionId).offsetTop;
                    window.scrollTo({ top: scrollDiv, behavior: 'smooth'});                
         */   
                    document.querySelector(targetSectionId).scrollIntoView({
                        behavior: 'smooth', block: "start", inline: "nearest"
                    });
   
                  });
          });
          
        }, 2000);  
    });  

/* Create Chapter Link Side Bar Section : End */      

/* Active Chapter Link on scroll : Start */

    window.addEventListener('DOMContentLoaded', () => {
    
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const id = entry.target.getAttribute('id');
          
          if (entry.intersectionRatio > 0) {
            document.querySelector(`.stickeySidebar_inner_chapter_list a[href="#${id}"].navigation__link`).classList.add('active');
            document.querySelector(`.stickeySidebar_inner_mobile_chapter_list a[href="#${id}"].mob_navigation__link`).classList.add('active');
            document.querySelector(`.stickeySidebar_inner_mobile_chapter_dots_list a[href="#${id}"].mob_dot_navigation__link`).classList.add('active');
          } else {
            document.querySelector(`.stickeySidebar_inner_chapter_list a[href="#${id}"].navigation__link`).classList.remove('active');
            document.querySelector(`.stickeySidebar_inner_mobile_chapter_list a[href="#${id}"].mob_navigation__link`).classList.remove('active');
            document.querySelector(`.stickeySidebar_inner_mobile_chapter_dots_list a[href="#${id}"].mob_dot_navigation__link`).classList.remove('active');
          }
        });
      });
    
      // Track all sections that have an `id` applied
      document.querySelectorAll('.page-sectionChapter div[id].chapter_section_outer_block').forEach((section) => {
        observer.observe(section);
      });
      
    });  
  
/* Active Chapter Link on scroll : End */  

/* >> Adding Sticky Feature to Chapter Link Side Bar Section : Start */  
  
    window.onscroll = function(e) { 
      var barInfoSticky = document.querySelector('.stikcy_panel_info_bar');
      var barInfoHeight = document.querySelector('.page-chapter-wrapper-block-list');  
      
      var barAddToCartSticky = document.querySelector('.page-chapter-wrapper-section');  
      var barAddToCartSticky_top = barAddToCartSticky.offsetTop;
      
      var fixedBox = document.querySelector("#mainNav");
    
      var get_info_height_offsettop = barInfoHeight.scrollHeight + barAddToCartSticky_top;
      var get_info_bottom_stop = get_info_height_offsettop - window.innerHeight + 100;
      
      if(window.scrollY > barAddToCartSticky_top){
        console.log("activeFixed");
        barInfoSticky.innerHTML= window.scrollY+' = '+barAddToCartSticky_top+ ' Info height = '+barInfoHeight.scrollHeight+' height+ offtop = '+get_info_height_offsettop +'  Window Height = '+window.innerHeight+ ' Bottom Stop = '+get_info_bottom_stop;
        fixedBox.classList.add("activeFixed");        
      }else{
        console.log("reactiveFixed");
        barInfoSticky.innerHTML= window.scrollY+' = '+barAddToCartSticky_top+ ' Info height = '+barInfoHeight.scrollHeight+' height+ offtop = '+get_info_height_offsettop +'  Window Height = '+window.innerHeight+ ' Bottom Stop = '+get_info_bottom_stop;
        fixedBox.classList.remove("activeFixed");    
      }
    
      if(window.scrollY > get_info_bottom_stop){    
        fixedBox.classList.add("activeFixedBottom");        
      }else{
        fixedBox.classList.remove("activeFixedBottom");    
      }      
    }
      
/* Adding Sticky Feature to Chapter Link Side Bar Section : End */ 

  

  } catch(e) { console.error(e); }
})();
})();
